export class GeozipDto {
    geozip = '';
    beginZipCode = '';
    endZipCode = '';
    zipArea = '';
}
